import { faCheck, faClose, faEdit, faPrint, faTrash, faUserLargeSlash, faVanShuttle, faX } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button,Table } from "react-bootstrap";
import Spinner from "../../components/Spinner/Spinner"
import { useDispatch, useSelector } from "react-redux";
import getVanlist from "../../utilities/getVanList";
import * as listVansActions from "../../redux/listVans/listVansActions"
import Modal from 'react-modal';
import { useEffect, useState } from "react";
import { faO } from "@fortawesome/free-solid-svg-icons/faO";
import { faSlidersH } from "@fortawesome/free-solid-svg-icons/faSlidersH";
import deleteVan from "../../utilities/deleteVanUid";

import generarPDF from "../../utilities/create-pdf";

function ListVansBody() {
     const dispatch = useDispatch();
     const listVans = useSelector(state => state.vansList.vansList);
     const token = useSelector((state)=> state.us.current?.token);
     const [loading , setLoading] = useState(false);
     const [pageValue, setPageValue] = useState(0);
     const [openInfo, setOpenInfo] = useState(false);
     const [infoVans, setInfoVans] = useState(null);
     const [openDelete, setOpenDelete] = useState(false);
     const [vanUid, setVanUid] = useState(null)
     
     useEffect(() => {
     
      if (infoVans) {
      setOpenInfo(prev => !prev)
      
     }
    }, [infoVans]);

     const handleChangePage = (e) => {
       setLoading(true);
       setPageValue(e.target.value);
       getVanlist(e.target.value, 10, token)
       .then(res => {
        dispatch(listVansActions.setVansLists(res.data)); 
        setLoading(false);
        })
        .catch(err => {
        console.error(err);
        setLoading(false);
        })
       
      
     
     } 
      const hasTrueBoolean = (obj) => {
        let falso = true
        let value = Object.values(obj);
        let booleanValues = value.filter(v => typeof v === "boolean");
        booleanValues.map((v) => {
          if(v == false) {
            return falso = false
          }
        })
        
        return falso
      }

     const handleOpenInfo = async (info) =>  
      { 
       setInfoVans(info);
      }

      const handleOpenDelete = (uid) => {
          setVanUid(uid);
          
          setOpenDelete(prev => !prev)
      }
      const handleYesDeleteVan = () => {
        setOpenInfo(false)
        setLoading(true);
        deleteVan(vanUid.uid, token)
        .then(res => {
            
        getVanlist(pageValue, 10, token)
       .then(res2 => {
        dispatch(listVansActions.setVansLists(res2.data)); 
        setLoading(false);
         setOpenDelete(prev => !prev);
         
        })
        .catch(err => {
         setOpenDelete(prev => !prev)
        setLoading(false);
        })
             
        })
        .catch(err2 => {
           setOpenDelete(prev => !prev)
          setLoading(false);
        })
      }

    
   
     if (listVans == null || loading) {
          return <>
          <Spinner/>
          </>   
    } else {
      const pages = [];
            for (let i = 0; i < Math.floor(listVans.total / 10 + 1); i++) {
              pages.push(i * 10);
            }
            
        return (
            <>
            
            <div className="van-list-father mt-5">
        
              <Table striped bordered hover >
                <thead>
                      <tr>
                       <th></th>
                       <th>Vehicule N°:</th>
                       <th>Date:</th>
                       <th> </th>
                      </tr>
               </thead>
                <tbody>  
     
              { listVans.vans.map((van) => (
                
                <tr key={van.uid}>
                  
                <td>
                <Button variant={hasTrueBoolean(van) ? 'success' : 'danger'} onClick={()=> handleOpenInfo(van)}>
                <FontAwesomeIcon
                
                icon={faVanShuttle}
                size="2x"
                style={{ cursor: 'pointer', color: 'white' }}
                />
                </Button>
                </td>
                <td>{van.vehicleRegistrationNumber}</td>
                <td>{van.date}</td>
                <td>
                <Button variant="secondary" onClick={() => handleOpenDelete(van)}>
                <FontAwesomeIcon
                icon={faTrash}
                size="1x"
                style={{ cursor: 'pointer', color: 'white' }}
                />
                </Button>
                </td>
                </tr>
                )) } 
                
          </tbody>
    </Table>
    
      <div className="d-flex align-items-center justify-content-center mb-3 mt-4">
         <label htmlFor="vanSelect" className="form-label me-2 mb-0">
         Page:
        </label>
         <select  
          className="form-select w-auto"
          aria-label=""
          onChange={handleChangePage}
          value={pageValue} 
          
          >
          
                {pages.map((v)=>{
                  return <option key={v} value={v} >{Math.floor(v / 10 + 1)}</option>
                  
                })}
               
          </select>
      </div> 
    
    </div>    
     {/* Modal view info */}
      <Modal
            isOpen={openInfo}     
            overlayClassName="glass-overlay"
            className="card modal-custom"
            data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000"
          >
         <div className="card p-2  modal-body-scroll ">
            <div className="card-header  mb-4 d-flex justify-content-center">  

            </div>
            <div className=" text-body-secondary d-flex justify-content-between">
              <div>
                <p>
                 🚚 Vehicule N°: {infoVans?.vehicleRegistrationNumber}
                </p>    
              </div>
              <div>
                <button className="btn btn-primary  " onClick={handleOpenInfo}>
                 <FontAwesomeIcon icon={faClose}/>
                </button>
              </div>
             </div>
         <div className="card-header">
           
          </div>
         <div className="">
             <h5 className="card-title mt-1 text-decoration-underline">Info</h5>
              <p className="card-text"><strong>Vehicule N°:</strong> {infoVans?.vehicleRegistrationNumber}</p>
              <p className="card-text"><strong>Date:</strong> {infoVans?.date}</p>
              <p className="card-text"><strong>Check created by:</strong> {infoVans?.userMail}</p>
              <hr></hr>
              <h5 className="card-title mt-1 text-decoration-underline">Exterior Condition</h5>
               <p className="card-text"><strong>Bodywork:</strong> {infoVans?.bodyWork ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>} </p>
               <p className="card-text"><strong>Bodywork panels:</strong> {infoVans?.bodyWorkPanels ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>} </p>
               <p className="card-text"><strong>Mirrors:</strong> {infoVans?.mirrors ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Mirrors Clean:</strong> {infoVans?.mirrorsClean ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Windows:</strong> {infoVans?.windows ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Windows Clean:</strong> {infoVans?.windowsClean ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Wipers:</strong> {infoVans?.wipers ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Windscreen Washer:</strong> {infoVans?.windScreenWasher ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Rear Wiper:</strong> {infoVans?.rearWiper ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Headlights:</strong> {infoVans?.headLights ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Sidelights (Parking Lights):</strong> {infoVans?.sideParkingLights ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Indicators:</strong> {infoVans?.indicators ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Brake Lights:</strong> {infoVans?.brakeLights ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Hazard Warning Lights:</strong> {infoVans?.hazardWarningLights ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Number Plate Light:</strong> {infoVans?.numberPlateLight ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Fog Lights:</strong> {infoVans?.fogLights ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Tyres Condition:</strong> {infoVans?.tyreCondition ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Tyres Pressure:</strong> {infoVans?.tyrePressure ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Tyres Depth:</strong> {infoVans?.tyresDepth ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Valve caps</strong> {infoVans?.valveCaps ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Wheels:</strong> {infoVans?.wheels ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Number Plates:</strong> {infoVans?.numberPlates ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <hr></hr>
               <h5 className="card-title mt-1 text-decoration-underline">Under the Bonnet</h5>
               <p className="card-text"><strong>Engine Oil:</strong> {infoVans?.engineOil ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Coolant:</strong> {infoVans?.coolant ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Brake Fluid:</strong> {infoVans?.brakeFluid ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Power Steering Fluid:</strong> {infoVans?.powerSteeringFluid ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Leaks:</strong> {infoVans?.leaks ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <hr></hr>
               <h5 className="card-title mt-1 text-decoration-underline">Interior Checks</h5>
               <p className="card-text"><strong>Driver Seat:</strong> {infoVans?.driverSeat ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Pedals:</strong> {infoVans?.pedals ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Steering Wheel:</strong> {infoVans?.steeringWheel ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Seat Belts:</strong> {infoVans?.seatBelts ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Horn:</strong> {infoVans?.horn ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Warning Lights:</strong> {infoVans?.warningLights ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Foot Brake:</strong> {infoVans?.footBrake ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Parking Brake:</strong> {infoVans?.parkingBrake ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Load Security:</strong> {infoVans?.loadSecurity ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <hr></hr>
               <h5 className="card-title mt-1 text-decoration-underline">Documentation Equipment</h5>
               <p className="card-text"><strong>Vehicule Documentation:</strong> {infoVans?.vehiculeDocumentation ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Warning triangle and high-visibility vest</strong> {infoVans?.warningTrianguleHighVibilityVest ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>First-aid kit:</strong> {infoVans?.firstAidKit ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <p className="card-text"><strong>Fire extinguer:</strong> {infoVans?.fireExtinguisher ? <FontAwesomeIcon color="green" icon={faCheck}/> : <FontAwesomeIcon color="red" icon={faX}/>}</p>
               <hr></hr>
               <p className="card-text"><strong>Additonal Report (optional):</strong> <i></i>{infoVans?.anotherReport ? <i>{infoVans.anotherReport}</i>  : '' }</p>
               <hr></hr>


        <div className="d-flex justify-content-between">

        <button className="btn btn-primary" onClick={handleOpenInfo}>Close</button>
        <div>

        <button className="btn btn-success me-2" onClick={()=>generarPDF(infoVans)}><FontAwesomeIcon icon={faPrint}/></button>
        <button className="btn btn-secondary " onClick={()=>handleOpenDelete(infoVans)}><FontAwesomeIcon icon={faTrash}/></button>
        </div>
        </div>
        </div>

      
        </div> 
      </Modal>

        <Modal
                 isOpen={openDelete}     
                 overlayClassName="glass-overlay"
                 className="glass-content card"
                 data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000"
               >
               <div></div>
               <h5 className="card-header">Delete Van Check <FontAwesomeIcon icon={faVanShuttle}/></h5>
               <p>Vehicule N°: {vanUid?.vehicleRegistrationNumber}</p>
               <p>Date: {vanUid?.date} </p>
               <div className="card-body">
                <h5 className="card-title">Do you want to delete this van check:</h5>
            
              <div className="d-flex justify-content-between mx-auto" style={{ width: '90%' }}>
              <button className='btn btn-danger'  style={{ width: '45%' }} onClick={handleYesDeleteVan}>YES</button>
               <button className='btn btn-primary'  style={{ width: '45%' }} onClick={handleOpenDelete}>NO</button>
              </div>
               </div>
         </Modal>
    


      
      
      
      
      
      </>
    )
}
    
}

export default ListVansBody